// extracted by mini-css-extract-plugin
export var mediaSectionContainer = "mediaSection-module--mediaSectionContainer--Kxhcg";
export var mediaSectionHeadTextGrid = "mediaSection-module--mediaSectionHeadTextGrid--+q2DK";
export var mediaSectionHeadText = "mediaSection-module--mediaSectionHeadText--ZUxqX";
export var mediaSectionMedia = "mediaSection-module--mediaSectionMedia--nFBgf";